export default __webpack_public_path__ + "static/media/newSet2-2-min.83624c6b.png";